module.exports = __webpack_public_path__ + "img/9.1029a992.jpg";